import PropTypes from 'prop-types';
import Navbar from '../components/layout/public/Navbar';
import Footer from '../components/layout/public/Footer';
import ChatbaseLoader from '../components/common/ChatbaseLoader';

/**
 * PublicLayout - Main layout wrapper for public-facing pages
 * 
 * CRITICAL: This project uses React Router 5, NOT React Router 6!
 * - React Router 5: Use component/render props, NOT <Outlet />
 * - React Router 5: Use <Switch>, NOT <Routes>
 * - React Router 5: Use useHistory, NOT useNavigate
 * 
 * This layout is used for:
 * - Landing page
 * - Templates list
 * - About, Contact, FAQ
 * - Pricing
 * - Legal pages (Privacy, Terms, KVKK)
 * 
 * Phase 2 will add: AuthLayout (Login/Register)
 * Phase 3 will add: AdminLayout (Dashboard/Admin panel)
 * 
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Page content to render
 * @returns {JSX.Element} PublicLayout component
 */
const PublicLayout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      {/* Navbar - T2.2 ✅ */}
      <Navbar />
      
      {/* Main Content Area - React Router 5 children prop */}
      <main className="flex-1">
        {children}
      </main>
      
      {/* Footer - T2.3 ✅ */}
      <Footer />
      <ChatbaseLoader layoutType="public" />
    </div>
  );
};

PublicLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PublicLayout;

